import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressServiceService {

  constructor(
    private http: HttpClient
  ) { }

  getAddress(usrId: any): Observable<any> {
    return this.http.get<any>(`/api/getAddress?usr=${usrId}`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  addAddress(payload: any): Observable<any> {
    return this.http.post<any>(`/api/addAddress`, payload).pipe(
      map((res: any) => {
        return res;
      })
    );
  }



}
